'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Footer from 'Components/Navigation/Footer';
import config from 'Shared/config';
const app = window.app;
export default class WhiteLabel extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const meta_tags = props.meta_title ? /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, props.meta_title), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: props.meta_description
    }), /*#__PURE__*/React.createElement("meta", {
      property: "og:title",
      content: props.meta_title
    }), props.meta_follow === true ? /*#__PURE__*/React.createElement("meta", {
      name: "robots",
      content: "index, follow"
    }) : /*#__PURE__*/React.createElement("meta", {
      name: "robots",
      content: "noindex, nofollow"
    })) : undefined;
    const style = props.background ? {
      backgroundImage: 'url(' + props.background + ')'
    } : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: "front-page direct-booking-page",
      style: style
    }, meta_tags, props.children, /*#__PURE__*/React.createElement(Footer, {
      simple: true
    }));
    return output;
  }
}
WhiteLabel.propTypes = {
  meta_follow: PropTypes.bool,
  meta_description: PropTypes.string,
  meta_title: PropTypes.string
};
WhiteLabel.defaultProps = {
  meta_follow: true,
  meta_title: config.site_name,
  meta_description: config.meta_description
};
